import React from 'react';

export const NOT_RECEIVED_VALUE = 'NOT_RECEIVED';
export const NO_RECEIPTS_VALUE = 'NO_RECEIPTS';

export const RECEIVABLE_STATUSES = canViewPimsWarnings => ({
  NO_RECEIPTS: {
    value: NO_RECEIPTS_VALUE,
    label: 'No Receipts',
    filterLabel: 'No Receipts',
    color: 'neutral',
    show: true,
  },
  IN_PROGRESS: {
    value: 'IN_PROGRESS',
    label: 'In Progress',
    filterLabel: 'In Progress',
    color: 'warning',
    show: true,
  },
  PARTIALLY_RECEIVED: {
    value: 'PARTIALLY_RECEIVED',
    label: 'Partially Received',
    filterLabel: 'Partially Received',
    color: 'warning',
    show: true,
  },
  FULLY_RECEIVED: {
    value: 'FULLY_RECEIVED',
    label: 'Fully Received',
    filterLabel: 'Fully Received',
    color: 'success',
    show: true,
  },
  NOT_RECEIVED: {
    value: NOT_RECEIVED_VALUE,
    label: 'No Receipts',
    filterLabel: '', // not received isn't used in filters
    color: 'neutral',
    show: true,
  },
  PARTIALLY_RECEIVED_WITH_WARNINGS: {
    value: 'PARTIALLY_RECEIVED_WITH_WARNINGS',
    label: 'Partially Received',
    filterLabel: 'Partially Received with Warnings',
    color: 'warning',
    show: canViewPimsWarnings,
    icon: canViewPimsWarnings ? ['fas', 'comment-exclamation'] : null,
  },
  FULLY_RECEIVED_WITH_WARNINGS: {
    value: 'FULLY_RECEIVED_WITH_WARNINGS',
    label: 'Fully Received',
    filterLabel: 'Fully Received with Warnings',
    color: 'success',
    icon: canViewPimsWarnings ? ['fas', 'comment-exclamation'] : null,
    show: canViewPimsWarnings,
  },
  NOT_RECEIVABLE: {
    value: 'NOT_RECEIVABLE',
    label: 'Not Receivable',
    filterLabel: 'Not Receivable',
    color: 'primary',
    show: true,
    tooltip: 'There are no receivable items on this order. All items are marked as backordered, cancelled, or not receivable. If you believe this is an error, please reach out via the Vetcove Live Chat.'
  },
  INCOMPLETE_ORDER: {
    value: 'INCOMPLETE_ORDER',
    label: 'Incomplete',
    filterLabel: 'Incomplete',
    color: 'primary',
    show: true,
    tooltip: 'One or more items are backordered, cancelled, or marked as not receivable on this order. If you believe this is an error, please reach out via the Vetcove Live Chat.'
  },
});

export const FAILED_TO_SEND_VALUE = 'FAILED_TO_SEND';

export const RECEIVABLE_WARNINGS = canViewPimsWarnings => ({
  FAILED_TO_SEND: {
    value: FAILED_TO_SEND_VALUE,
    label: 'Failure sending to PIMS',
    show: canViewPimsWarnings,
  },
  NEEDS_LOT_NUMBERS: {
    value: 'NEEDS_LOT_NUMBERS',
    label: 'Items missing lot numbers',
    show: true,
  },
  NO_PURCHASE_ORDER_FOUND: {
    value: 'NO_PURCHASE_ORDER_FOUND',
    label: 'No purchase order found',
    show: true,
  },
  NO_PURCHASE_ORDER_SET: {
    value: 'NO_PURCHASE_ORDER_SET',
    label: 'No purchase order number set',
    show: true,
  },
  NOT_FULLY_RECEIVED: {
    value: 'NOT_FULLY_RECEIVED',
    label: 'Not all items received',
    show: true,
  },
  NO_ITEMS_RECEIVED: {
    value: 'NO_ITEMS_RECEIVED',
    label: 'No items in purchase order',
    show: true,
  },
  NO_WARNINGS: {
    value: 'NO_WARNINGS',
    label: 'No warnings',
    show: true,
  },
});

export const ITEM_WARNING_MESSAGES = {
  NO_ITEM_LINK: {
    message: (
      <>
        <strong>Error sending item to PIMS: </strong>
        There is no corporate item link available for items received. If there are questions, please reach out to your corporate support.
      </>
    ),
    color: 'warning',
  },
  NO_PIM_PRODUCT: {
    message: (
      <>
        <strong>Did not send to PIMS: </strong>
        We could not find an active product in your PIMS for this item. If this is not expected, please reach out for help.
      </>
    ),
    color: 'primary'
  }
};

export const WARNING_MESSAGES = {
  ITEM_WARNINGS_EXIST: 'One or more received items could not be transmitted to your PIMS. Review items below.',
  BUYER_NOT_ELIGIBLE: "Your clinic's Vetcove account is not properly set up for receiving by your corporate group.",
  EXPIRED_ATTEMPTS: 'This receipt will not transmit to your PIMS as it was created too far in the past. Please review your inventory adjustments in your PIMS and adjust quantities accordingly.',
  UNCONFIRMED_ATTEMPT: 'We were not able to confirm whether this receipt was successfully sent to your PIMS.'
  + ' Please review your inventory adjustments in your PIMS to ensure the item quantities were updated successfully, and if not, please adjust quantities accordingly.',
  FAILURE_THRESHOLD: 'Hit the maximum number of failure attempts to transmit to your PIMS.'
  + ' Please review your inventory adjustments in your PIMS to ensure the item quantities were updated successfully, and if not, please adjust quantities accordingly.'
};

export const RECEIVABLE_NOTE_KINDS = {
  GENERAL: 'General Note',
  NO_ITEM: 'One or more items never arrived',
  BROKEN_ITEM: 'One or more items arrived broken or damaged',
  WRONG_ITEM: 'One or more items did not match what was ordered',
  BACKORDER_ITEM: 'One or more items are currently on backorder',
  OTHER: 'One or more items had some other issue'
};
